export enum MATCHMAKER_STATUS {
  CREATED = 'CREATED',
  COMPLETED = 'COMPLETED',
}

export enum Step {
  UPLOAD,
  SEARCHING,
  RESULT,
  GROUP_RESULT,
  SUCCESS,
  TIMEOUT
}

export interface MatchmakerMatch {
  email: string;
  name?: string;
  title?: string;
  picture?: string;
}
export interface Matchmaker {
  participants : MatchmakerMatch[]
  participantEmails: string[];
  status: MATCHMAKER_STATUS;
}

//Transformation functions
export const transformResponseToMatchmaker = (response: any): Matchmaker => {
  if (response.participantOneEmail === "MATCHMAKER_STATUS") {

    return {
      status: MATCHMAKER_STATUS.CREATED,
      participants: [
          {
          title: response.participantOneTitle,
          name: response.participantOneName,
          email: response.participantOneEmail
        },
      {
        name: response.participantTwoName,
        title: response.participantTwoTitle,
        email: response.participantTwoEmail
      },
      {
        name: response.participantThreeName,
        title: response.participantThreeTitle,
        email: response.participantThreeEmail
      },
    ],
      participantEmails: [],
    }
  } else {
    return {
      status: MATCHMAKER_STATUS.COMPLETED,
      participants: [
          {
          title: response.participantOneTitle,
          name: response.participantOneName,
          email: response.participantOneEmail
        },
      {
        name: response.participantTwoName,
        title: response.participantTwoTitle,
        email: response.participantTwoEmail
      },
      {
        name: response.participantThreeName,
        title: response.participantThreeTitle,
        email: response.participantThreeEmail
      },
    ],
      participantEmails: [],
    }
  }
};
